import * as React from "react";
import {RightOutlined} from "../assets/svgs/RightOutlined";

type Props = {
  parentLabel: string;
  childLabel: string;
}

export function Breadcrumb({
                             parentLabel, childLabel
                           }: Props) {
  return (<div className={"flex gap-[5px] items-center text-sm font-normal"}>
    <span className={"text-black/25"}>{parentLabel}</span>
    <RightOutlined className={"text-black/45 w-3"}/>
    <span className={"text-black/85"}>{childLabel}</span>
  </div>);
}
